import React, { useEffect, useState } from 'react';
import BotoneraConfederaciones from './BotoneraConfederaciones.js';
import LinkPlus from '../UI/LinkPlus.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import PanelHeaderColapsable from '../UI/PanelHeaderColapsable.js';
import { EsObjeto } from '../funciones/Funciones.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './CuadroPaises.module.css';
import useMediaQuery from '../../hooks/useMediaQuery.js';

const CuadroPaises = (props) => {
  const incluirPrincipales = EsObjeto(props.incluirPrincipales) ? props.incluirPrincipales : false;
  const pathLinks = props.pathLinks;
  const titulo = props.titulo;
  const [principales, setPrincipales] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const esDesktop = useMediaQuery('(min-width: 1200px)');

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (incluirPrincipales) {
      fetchData('paises?principales=true', setPrincipales);
    } else {
      setPrincipales(null);
    }
  }, [incluirPrincipales, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <PanelHeaderColapsable
        titulo={titulo || 'Por país'}
        colapsableEnMobile={true}
        breakpoint={1024}
        expandidoInicial={false}
        ariaLabelToggle="Expandir o contraer por país"
        alwaysContent={
          <React.Fragment>
            <MensajeCargando isCargando={isCargando} />
            <MensajeError errores={erroresGetLista} />
          </React.Fragment>
        }
      >
        <React.Fragment>
          {principales && esDesktop && (
            <React.Fragment>
              <span className={`${styles.tituloSeccion}`}>Principales</span>
              {principales.map((pais) => (
                <LinkPlus className={`${styles.listItem}`} key={pais.id} to={pathLinks + pais.id}>
                  {pais.nombre}
                </LinkPlus>
              ))}
            </React.Fragment>
          )}
          <div className={`${styles.botoneraConfederaciones}`}>
            <BotoneraConfederaciones pathLinks={pathLinks} />
          </div>
        </React.Fragment>
      </PanelHeaderColapsable>
    </div>
  );
};

export default CuadroPaises;
